import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_PROJECT_HEALTH_API } from "./apiRoutes";

interface Props {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getProjectHealth = async () => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_PROJECT_HEALTH_API}`);
};

const useGetProjectHealth = ({ queryParams }: Props = {}): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-project-health"],
    queryFn: () => getProjectHealth(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetProjectHealth;
